import React, { useState, useEffect, useRef } from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import API from '../http/API';
import { useCourt, useRequestUrl, useOrgState, useCaptchaKey } from '../context/contextHooks';
import { getBalanceQuery, toPaymentBalance, toPaidPlan, getCourtAmount, getFeeQuery,
    getPaymentRequest, validateAddBalance, validateAddPlan, validatePayment,
    showTrafficSchool, getTrafficSchoolText, showPlea, validateLookup,
    getPartialPaymentValidation, showBond, validatePaymentAmounts } from "./lookupFunctions";
import { checkMultipleParties, getPartyData, removePaidPartyBals} from "./partyFunctions";
import {getOptionCompletionText, getOptionTemplateName} from "./trafficSchool/optionFunctions";
import { useStyles } from "../styles/styles";
import Box from '@mui/material/Box';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from "@mui/material/CircularProgress";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';
import LookupForm from "./LookupForm";
import PartyList from "./PartyList";
import BalanceList from "./BalanceList";
import PlanList from "./PlanList";
import SelectedBalances from "./SelectedBalances";
import Button from "@mui/material/Button";
import CompletePayment from '../completePayment/CompletePayment';
import ManageWidget from "../widgetPay/ManageWidget";
import PaymentDetails from '../completePayment/PaymentDetails';
import Popup from '../layout/Popup';
import ConfirmPopup from "../layout/ConfirmPopup";
import BondPopup from "../layout/BondPopup";
import { HtmlComponent } from "../global/components";
import OptionTemplateSource from "./trafficSchool/OptionTemplateSource";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import parse from "html-react-parser";

const BalanceLookup = () => {
    const navigate = useNavigate();
    const [, setOrgState] = useOrgState();
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [requestUrl,] = useRequestUrl();
    const [court, ] = useCourt();
    const location = useLocation()
    const message = court.balanceListNotice
    const [loading, setLoading] = useState(false);
    const [actionResponse, setActionResponse] = useState(null);
    const [balanceData, setBalanceData] = useState(null);
    const [partyData, setPartyData] = useState(null);
    const [displayData, setDisplayData] = useState(null);
    const [selectedBalances, setSelectedBalances] = useState([]);
    const [selectedPlans, setSelectedPlans] = useState([]);
    const [showSelected, setShowSelected] = useState(false);
    const [openSelectedClicked, setOpenSelectedClicked] = useState(false);
    const [feeResponse, setFeeResponse] = useState(null);
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [paymentResult, setPaymentResult] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openReceipt, setOpenReceipt] = useState(false);
    const [checkTrafficSchool, setCheckTrafficSchool] = useState(false);
    const [trafficSchoolDone, setTrafficSchoolDone] = useState(false);
    const [openOption, setOpenOption] = useState(false);
    const [optionTemplate, setOptionTemplate] = useState(null);
    const [checkOptionForm, setCheckOptionForm] = useState(false);
    const [optionFormData, setOptionFormData] = useState(false);
    const [openOptionForm, setOpenOptionForm] = useState(false);
    const [checkPlea, setCheckPlea] = useState(false);
    const [pleaDone, setPleaDone] = useState(false);
    const [openPlea, setOpenPlea] = useState(false);
    const [checkBond, setCheckBond] = useState(false);
    const [bondDone, setBondDone] = useState(false);
    const [openBond, setOpenBond] = useState(false);
    const [bondOptionalAgreed, setBondOptionalAgreed] = useState(false);
    const [graphicResponse, setGraphicResponse] = useState(null);
    const [caseGraphicResponse, setCaseGraphicResponse] = useState(null);
    const [citationImage, setCitationImage] = useState(null);
    const [caseImage, setCaseImage] = useState(null);
    const [partialPayment,setPartialPayment] = useState(false);
    const [propsData, setPropsData] = useState(location.state);
    const [savedPartyData, setSavedPartyData] = useState(null);
    const [partyRequest, setPartyRequest] = useState(null);
    const [captchaKey, setCaptchaKey] = useCaptchaKey();
    const balanceListRef = useRef(null);
    const searchButtonRef = useRef(null);


    const clearMessaging = () => {
        setActionResponse(null);
    }


    const clearData = () => {
        setBalanceData(null);
        setPartyData(null);
        setDisplayData(null);
        clearSelected();
    }

    const goBack = () => {
        setOrgState('');
        clearData();
        setSavedPartyData(null);
        setTrafficSchoolDone(false);
        setOptionFormData(null);
        setPleaDone(false);
        setBondDone(false);
        setSelectedBalances([]);
        navigate('/home');
    }

    const findBalances = (form, dob) => {
        setTrafficSchoolDone(false);
        setOptionFormData(null);
        setPleaDone(false);
        setBondDone(false);
        setSavedPartyData(null);
        const errors = validateLookup(form, court, dob);
        if (errors && errors.length > 0) {
            setActionResponse({error: true, errorMessage: errors});
        } else {
            clearMessaging();
            clearData();
            setLoading(true);
            const query = getBalanceQuery(court, form, dob);
            const url = `${requestUrl}/searchBalances`
            API.postAction(url, query, 'findBalances', null, setActionResponse);
        }
        return errors;
    }

    const restorePartyData = () => {
        if (savedPartyData && savedPartyData.length > 0) {
            clearSelected();
            setDisplayData(null);
            setBalanceData(null);
            setPartyData(savedPartyData);
        }
    }

    const calculateFee = (selectedBals, selectedPlans) => {
        clearMessaging();
        setLoading(true);
        const courtAmt = getCourtAmount(selectedBals, selectedPlans);
        const url = `${requestUrl}/calculateFee`;
        API.postAction(url, getFeeQuery(court, courtAmt), 'calculateFee', null, setActionResponse);
    }

    const selectParty = (partyRec) => {
        const partyId = partyRec.balances[0].party.id;
        const caseNo = partyRec.balances[0].caseNumber;
        const query = {courtId: court.courtId}
        if (court.noPartyIds) {
            query.caseNumber = caseNo;
        } else query.partyId = partyId;
        if (partyRec.party?.dob) query.dob = partyRec.party.dob;
        setLoading(true);
        setTrafficSchoolDone(false);
        setOptionFormData(null);
        setPleaDone(false);
        setBondDone(false);
        setPartyData(null);
        const url = `${requestUrl}/searchBalances`
        API.postAction(url, JSON.stringify(query), 'findBalances', null, setActionResponse);
    }

    const selectBalance = (balance) => {
        clearMessaging();
        const pymtBal = toPaymentBalance(balance, court);
        const errors = validateAddBalance(pymtBal, selectedBalances, selectedPlans, court);
        if (errors && errors.length > 0) {
            setActionResponse({error: true, errorMessage: errors})
        } else {
            balance.selected = true;
            setSelectedBalances([...selectedBalances, pymtBal]);

            if (!selectedBalances.some(bal => bal.trafficSchoolId)) {
                setOptionTemplate(null);
                setOptionFormData(null);
            }
        }
    }

    const selectPlan = (plan) => {
        clearMessaging();
        const paidPln = toPaidPlan(plan);
        const errors = validateAddPlan(paidPln, selectedBalances, selectedPlans, court);
        if (errors && errors.length > 0) {
            setActionResponse({error: true, errorMessage: errors})
        } else {
            plan.selected = true;
            setSelectedPlans([...selectedPlans, paidPln]);
        }
    }
    const payAllBalances = () => {
        clearMessaging();
        const updatedSelectedBalances = [];
        let hasError = false;
        let trafficSchoolSelected = false;
        for (const balance of displayData.balances) {
            if (!balance.ineligibleForPayment && !balance.selected) {
                if (balance.trafficSchoolId && trafficSchoolSelected) {
                    setActionResponse({
                        error: true,
                        errorMessage: 'Only one traffic school option may be selected'
                    });
                    hasError = true;
                    break;
                }
                const pymtBal = toPaymentBalance(balance, court);
                const errors = validateAddBalance(pymtBal, selectedBalances, selectedPlans, court);
                if (errors && errors.length > 0) {
                    setActionResponse({
                        error: true,
                        errorMessage: errors
                    });
                    hasError = true;
                    break;
                }
                if (balance.trafficSchoolId) {
                    trafficSchoolSelected = true;
                }
            }
        }
        if (!hasError) {
            for (const balance of displayData.balances) {
                if (!balance.ineligibleForPayment && !balance.selected) {
                    balance.selected = true;
                    updatedSelectedBalances.push(toPaymentBalance(balance, court));
                }
            }
            setSelectedBalances([...selectedBalances, ...updatedSelectedBalances]);
        }
    };

    const removeBalance = (balance) => {
        clearMessaging();
        const refId = balance.refId;
        const updatedBalances = selectedBalances.filter(bal => bal.refId !== refId);
        setSelectedBalances(updatedBalances);
        displayData.balances.forEach(bal => {
            if (bal.refId === refId) {
                bal.selected = null;
                bal.partialAmt = null;
                bal.bondId = null;
            }
        });
        if (!updatedBalances.some(bal => bal.trafficSchoolId)) {
            setOptionTemplate(null);
            setOptionFormData(null);
        }
    }

    const removePlan = (plan) => {
        clearMessaging();
        const plnId = plan.planId;
        setSelectedPlans(selectedPlans.filter(pln => pln.planId !==plnId));
        displayData.plans.forEach(pln => {
            if (pln.planId === plnId) {
                pln.selected = null;
                pln.installments.forEach(i => i.checked = null);
            }});
    }

    const clearSelected = () => {
        selectedBalances.forEach(bal => removeBalance(bal));
        selectedPlans.forEach(pln => removePlan(pln));
        setSelectedBalances([]);
        setSelectedPlans([]);
        if (displayData) {
            for (const balance of displayData.balances) {
                balance.bondId = null;
            }
        }
    }

    const openPayment = () => {
        const errors = validatePayment(displayData, selectedBalances, court, feeResponse);
        if (errors && errors.length > 0) {
            setActionResponse({error: true, errorMessage: errors})
        } else {
            if (showTrafficSchool(selectedBalances, court) && !trafficSchoolDone) {
                setCheckTrafficSchool(true);
                setOptionTemplate(getOptionTemplateName(court, selectedBalances));
                openTrafficSchool();
            } else if (optionTemplate && !optionFormData) {
                setCheckOptionForm(true);
                openTrafficSchoolForm();
            } else if (showPlea(selectedBalances, court) && !pleaDone) {
                setCheckPlea(true);
                openPleaPopup();
            } else if (showBond(selectedBalances, court) && !bondDone) {
                setCheckBond(true);
                openBondPopup();
            } else {
                setCheckTrafficSchool(false);
                setTrafficSchoolDone(false);
                setCheckOptionForm(false);
                setCheckPlea(false);
                setPleaDone(false);
                setCheckBond(false);
                setBondDone(false);
                clearMessaging();
                const amtError = validatePaymentAmounts(selectedBalances, selectedPlans, feeResponse);
                if (amtError) {
                    setActionResponse({error: true, errorMessage: amtError})
                } else {
                    setPaymentRequest(getPaymentRequest(court, selectedBalances, selectedPlans, feeResponse,
                        bondOptionalAgreed, displayData.balances, optionFormData));
                    setOptionFormData(null);
                }
            }
        }
    }

    const openTrafficSchool = () => {
        setTrafficSchoolDone(false);
        setOpenOption(true);
    }

    const openTrafficSchoolForm = () => {
        setOptionFormData(null);
        setOpenOptionForm(true);
    }

    const openPleaPopup = () => {
        setPleaDone(false);
        setOpenPlea(true);
    }

    const openBondPopup = () => {
        setBondDone(false);
        setOpenBond(true);
    }

    const getOptionHtmlComponent = () => {
        const title = court.optionHeader ? court.optionHeader : 'Traffic School Terms and Conditions';
        const html = getTrafficSchoolText(selectedBalances, court);
        const notice = getOptionCompletionText(selectedBalances);
        return (
            <HtmlComponent title={title} component={html} notice={notice} />
        );
    }

    const getPleaHtmlComponent = () => {
        const title = court.pleaAsBond ? 'Accept Bond Conditions' : 'Enter a Plea';
        return (
            <HtmlComponent title={title} component={court.plea} />
        );
    }

    const optionFinished = () => {
        setOpenOption(false);
        if (court.noOptionAgree) setTrafficSchoolDone(true);
    }

    const pleaFinished = () => {
        setOpenPlea(false);
        if (court.noPleaAgree) setPleaDone(true);
    }

    const bondFinished = () => {
        setOpenBond(false);
    }

    const openSelected = () => {
        setOpenSelectedClicked(true);
    }

    const toggleSelected = (open) =>
        (event) => {
            if (
                event.type === 'keydown' &&
                (event.key === 'Tab' || event.key === 'Shift' || event.key === 'Enter' || event.key === ' ')
            ) {
                return;
            }
            setShowSelected(open);
    }

    const cancelPymt = () => {
        clearSelected();
        setFeeResponse(null);
    }

    useEffect(() => {
        document.title = `Balance Lookup - Neumo Payments`;
    }, []);


    useEffect(() => {
        if (!captchaKey && !loading) {
            clearMessaging();
            setLoading(true);
            const url = `${requestUrl}/getCaptchaKey`;
            API.getRetrieve(url, 'getCaptchaKey', null, setActionResponse);
        }
    }, [captchaKey, loading]);

    useEffect(() => {
        if (court.citationGraphic) {
            setGraphicResponse(null);
            const url = `${requestUrl}/getImage/${court.citationGraphic.key}`;
            API.getBinary(url, null, setGraphicResponse, setActionResponse);
        }
    }, [court.citationGraphic]);

    useEffect(() => {
        if (graphicResponse && !citationImage && court.citationGraphic) {
            const file = new Blob([graphicResponse], { type: court.citationGraphic.contentType });
            file.name = court.citationGraphic.fileName;
            setCitationImage(file);
        }
    }, [graphicResponse, citationImage, court.citationGraphic]);

    useEffect(() => {
        if (court.caseGraphic) {
            setCaseGraphicResponse(null);
            const url = `${requestUrl}/getImage/${court.caseGraphic.key}`;
            API.getBinary(url, null, setCaseGraphicResponse, setActionResponse);
        }
    }, [court.caseGraphic]);

    useEffect(() => {
        if (caseGraphicResponse && !caseImage && court.caseGraphic) {
            const file = new Blob([caseGraphicResponse], { type: court.caseGraphic.contentType });
            file.name = court.caseGraphic.fileName
            setCaseImage(file);
        }
    }, [caseGraphicResponse, caseImage, court.caseGraphic]);


    useEffect(() => {
        if (displayData!==null) {
            setPartialPayment(getPartialPaymentValidation(court, displayData))
        }}, [court,displayData]);

    const somethingSelected = () => {
        return ((selectedBalances && selectedBalances.length > 0) || (selectedPlans && selectedPlans.length > 0));
    }

    useEffect(() => {
        if (loading && actionResponse) {
            if (actionResponse.error && actionResponse.requestType !== 'partyBalances') {
                if (actionResponse.requestType === 'findBalances') {
                    setBalanceData(null);
                    setSelectedBalances([]);
                }
            } else {
                if (actionResponse.requestType === 'findBalances') {
                    setBalanceData(actionResponse.data);
                    setSelectedBalances([]);
                } else if (actionResponse.requestType === 'calculateFee') {
                    setFeeResponse(actionResponse);
                } else if (actionResponse.requestType === 'partyBalances') {
                    if (!actionResponse.error && actionResponse.data && actionResponse.data.balances) {
                        setBalanceData(actionResponse.data);
                    }
                } else if (actionResponse.requestType === 'getCaptchaKey') {
                    setCaptchaKey(actionResponse.data);
                }
            }
            setLoading(false);
        }
    }, [actionResponse])

    useEffect(() => {
        if (balanceData) {
            const hasMultiple = checkMultipleParties(balanceData);
            if (hasMultiple) {
                const pd = getPartyData(balanceData);
                setPartyData(pd);
                if (court.allowNameSearch) setSavedPartyData(pd);
            } else {
                setDisplayData(balanceData);
                setBalanceData(null);
            }
        }
    }, [balanceData])

    useEffect(() => {
        if ((selectedBalances && selectedBalances.length > 0) || (selectedPlans && selectedPlans.length > 0)) {
            setShowSelected(true);
            calculateFee(selectedBalances, selectedPlans);
        } else {
            setFeeResponse({citepayFee: 0, courtAmount: 0, totalAmount: 0})
        }
        setOpenSelectedClicked(false);
    }, [selectedBalances, selectedPlans, openSelectedClicked])

    useEffect(() => {
        if (showSelected) {
            const sentinels = document.querySelectorAll('[data-testid="sentinelStart"], [data-testid="sentinelEnd"]');
            sentinels.forEach((el) => {
                if (!el.getAttribute('role')) {
                    el.setAttribute('role', 'presentation');
                }
            });
        }
    }, [showSelected]);

    useEffect(() => {
        if (checkTrafficSchool && !openOption) {
            if (trafficSchoolDone) {
                openPayment();
            }
            setCheckTrafficSchool(false);
        }
    }, [openOption, checkTrafficSchool])

    useEffect(() => {
        if (checkOptionForm && !openOptionForm) {
            if (optionFormData) {
                openPayment();
            } else {
                setTrafficSchoolDone(false);
            }
            setCheckOptionForm(false);
        }
    }, [openOptionForm, checkOptionForm])

    useEffect(() => {
        if (checkPlea && !openPlea) {
            if (pleaDone) {
                openPayment();
            }
            setCheckPlea(false);
        }
    }, [openPlea, checkPlea])

    useEffect(() => {
        if (checkBond && !openBond) {
            if (bondDone) openPayment();
            setCheckBond(false);
        }
    }, [openBond, checkBond])

    useEffect(() => {
        if (paymentRequest) {
            setOpenDialog(true);
        } else {
            setTrafficSchoolDone(false);
            setPleaDone(false);
        }
    }, [paymentRequest])

    useEffect(() => {
        if (paymentResult) {
            if (court.allowNameSearch && savedPartyData) {
                if (paymentRequest.paymentPlans.length > 0) {
                    setSavedPartyData(null);
                } else {
                    const parties = removePaidPartyBals(paymentRequest, savedPartyData);
                    setSavedPartyData(parties);
                }
            }
            setOpenReceipt(true);
        }
    }, [paymentResult])

    useEffect(() => {
        if (!openReceipt && paymentResult) {
            clearData();
            setPaymentRequest(null);
            setPaymentResult(null);
        }
    }, [openReceipt])

    useEffect(() => {
        if (!loading && partyRequest) {
            clearMessaging();
            setTrafficSchoolDone(false);
            setOptionFormData(null);
            setPleaDone(false);
            setBondDone(false);
            setSavedPartyData(null);
            setLoading(true);
            const url = `${requestUrl}/searchBalances`
            API.postAction(url, partyRequest, 'partyBalances', null, setActionResponse);
            setPartyRequest(null);
        }
    }, [partyRequest, loading])

    useEffect(() => {
        if (!displayData && propsData && propsData.partyId && !partyRequest) {
            setPartyRequest(JSON.stringify({courtId: propsData.courtId, partyId: Math.floor(propsData.partyId), fromAdmin: true}));
            setPropsData(null);
        }
    }, [propsData, displayData, partyRequest])

    return (
        <>
            { paymentRequest && !paymentResult && captchaKey &&
                <>
                    { court.neumoPayOnline ?
                        <ManageWidget
                            openDialog={openDialog}
                            setOpenDialog={setOpenDialog}
                            paymentRequest={paymentRequest}
                            setPaymentRequest={setPaymentRequest}
                            setPaymentResult={setPaymentResult}
                            court={court}
                            feeResponse={feeResponse}
                            cancelPymt = {cancelPymt}
                        />
                        :
                        <CompletePayment
                            openDialog={openDialog}
                            setOpenDialog={setOpenDialog}
                            paymentRequest={paymentRequest}
                            setPaymentRequest={setPaymentRequest}
                            setPaymentResult={setPaymentResult}
                            court={court}
                        />
                    }
                </>
            }
            { paymentResult &&
                <PaymentDetails
                    paymentRequest={paymentRequest}
                    paymentResult={paymentResult}
                    openReceipt={openReceipt}
                    setOpenReceipt={setOpenReceipt}
                    court={court}
                />
            }
            { openOption &&
                <>
                    { court.noOptionAgree ?
                        <Popup
                            open={openOption}
                            setDone={optionFinished}
                            title={court.optionHeader ? court.optionHeader : 'Traffic School Terms and Conditions'}
                            component={getOptionHtmlComponent()}
                        /> :
                        <ConfirmPopup
                            open={openOption}
                            setAgreed={setTrafficSchoolDone}
                            setDone={optionFinished}
                            component={getOptionHtmlComponent()}
                        />
                    }
                </>
            }
            { openOptionForm &&
                <OptionTemplateSource
                    open={openOptionForm}
                    setOpen={setOpenOptionForm}
                    optionTemplate={optionTemplate}
                    setFormData={setOptionFormData}
                    court={court}
                    balances={selectedBalances}
                />
            }
            { openPlea &&
                <>
                    { court.noPleaAgree ?
                        <Popup
                            open={openPlea}
                            setDone={pleaFinished}
                            title={court.pleaAsBond ? 'Accept Bond Conditions' : 'Enter a Plea'}
                            component={getPleaHtmlComponent()}
                        /> :
                        <ConfirmPopup
                            open={openPlea}
                            setAgreed={setPleaDone}
                            setDone={pleaFinished}
                            component={getPleaHtmlComponent()}
                            agreeText={court.pleaAsBond ? 'I agree to these bond conditions' : 'I agree to enter the plea defined above'}
                        />
                    }
                </>
            }
            { openBond &&
                <BondPopup
                    open={openBond}
                    setDone={bondFinished}
                    setAgreed={setBondDone}
                    setOptionalAgreed={setBondOptionalAgreed}
                    court={court}
                />
            }
            <Typography variant={smallScreen ? 'h6' : 'h5'} component="h1" color='primary' sx={{...classes.title, marginTop: '1rem'}}>
                Find Balances to Pay at {court && court.reportingHeader ? court.reportingHeader : court.courtName}
            </Typography>
            <Box onClick={toggleSelected(false)} onKeyDown={toggleSelected(false)} role='presentation'>
                <Grid
                    container
                    spacing={3}
                    justifyContent="center"
                >
                    <Backdrop open={loading} sx={classes.backdrop}>
                        <CircularProgress color='inherit' />
                    </Backdrop>
                    <Grid item xs={12} md={4}>
                        { smallScreen && (balanceData || displayData) ?
                            <>
                                { savedPartyData && !partyData ?
                                    <Button
                                        variant='contained'
                                        fullWidth
                                        color='primary'
                                        startIcon={<ManageSearchIcon />}
                                        sx={classes.squashedButton}
                                        style={{marginTop: '1rem'}}
                                        onClick={() => restorePartyData()}
                                    >
                                        Restore Party Results
                                    </Button> :
                                    <Button
                                        variant='contained'
                                        fullWidth
                                        color='primary'
                                        sx={classes.squashedButton}
                                        style={{marginTop: '1rem'}}
                                        onClick={() => {
                                            setDisplayData(null);
                                            setPartyData(null);
                                            setBalanceData(null);
                                            setSelectedBalances(null);
                                        }}
                                    >
                                        New Search
                                    </Button>
                                }
                            </> :
                            <LookupForm
                                goBack={goBack}
                                findBalances={findBalances}
                                citationImage={citationImage}
                                caseImage={caseImage}
                                showRestore={savedPartyData && !partyData}
                                restorePartyData={restorePartyData}
                                searchButtonRef={searchButtonRef}
                            />
                        }
                        { somethingSelected() && !showSelected &&
                            <>
                                <Box component='div' sx={{...classes.root, display: 'flex', flexDirection: 'row-reverse', marginTop: '1rem'}} >
                                    <Button
                                        variant='contained'
                                        fullWidth
                                        color='primary'
                                        sx={classes.squashedButton}
                                        onClick={openSelected}
                                    >
                                        See Selected Balances
                                    </Button>
                                </Box>
                            </>
                        }
                    </Grid>
                    <Grid item xs={12} md={8} sx={{...classes.gridBottom, padding: '0 .5rem'}}>
                        {actionResponse && actionResponse.error &&
                            <Alert id="lookup-error" severity='error'>
                                <AlertTitle>Error</AlertTitle>
                                {actionResponse.errorMessage}
                            </Alert>
                        }
                        { partyData && !displayData &&
                            <PartyList partyData={partyData} court={court} selectParty={selectParty}/>
                        }
                        {displayData && displayData.balances && displayData.balances.length > 0 && displayData.balances[0].party &&
                            <Typography variant='h6' component='h2' color='primary' sx={{...classes.title, fontSize: '1.3rem', marginTop: '0.7rem'}}>
                                Balances for {displayData.balances[0].party.partyName}
                            </Typography>
                        }
                        {message && displayData && displayData.balances && displayData.balances.length > 0 && (
                            <Typography sx={{marginBottom: '0.5rem'}}>{parse(message)}</Typography>
                        )}
                        {displayData && displayData.plans && displayData.plans.length > 0 &&
                            <PlanList plans={displayData.plans} selectPlan={selectPlan} />
                        }
                        {displayData && displayData.recurringPaymentsUrl && (
                            <Typography variant="subtitle1" component="p" sx={{fontSize: '1.2rem', marginTop: '1rem', paddingLeft: '1.5rem', textAlign: 'left'}} >
                                <Link href={displayData.recurringPaymentsUrl} target="_blank">Setup automatic payments for your payment plan(s)</Link>.
                                &nbsp;We recommend that you use a tablet or larger screen.
                            </Typography>
                        )}
                        {displayData && displayData.balances && displayData.balances.length > 0 &&
                            <BalanceList balances={displayData.balances} court={court} partialPayment={partialPayment} selectBalance={selectBalance} payAll={payAllBalances} ref={balanceListRef} />
                        }
                        <Drawer
                            anchor='right'
                            open={showSelected}
                            onClose={toggleSelected(false)}
                            closeAfterTransition={true}
                            PaperProps={{style: {width: smallScreen ? '70vw' : '50vw', margin: '1rem', padding: '1rem'}}}
                        >
                            <SelectedBalances
                                plans={selectedPlans}
                                balances={selectedBalances}
                                nonCourt={court.nonCourtOrganization}
                                splitFees={court.onlineCheckFeeConfig && !court.noChex}
                                removeBalance={removeBalance}
                                removePlan={removePlan}
                                feeResponse={feeResponse}
                                clearSelected={clearSelected}
                                openPayment={openPayment}
                                setShowSelected={setShowSelected}
                                focusRef={searchButtonRef}
                            />
                        </Drawer>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default BalanceLookup;
